// loader-service.ts
import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private loadingCount = 0;

  // Signal to track loading state
  private _isLoading = signal(false);

  // Expose the signal as readonly for components
  public readonly isLoadingSignal = this._isLoading;

  show() {
    this.loadingCount++;
    setTimeout(() => {
      this._isLoading.set(true);
    });
  }

  hide() {
    this.loadingCount--;
    if (this.loadingCount <= 0) {
      this.loadingCount = 0;
      this._isLoading.set(false);
    }
  }
}
